import React, { Component } from 'react';
import { Tabs, Tab, Button, ButtonToolbar, Col } from 'react-bootstrap';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { SchedulesCommand } from '../commands/SchedulesCommand';
import { SchedulesDraftCommand } from '../commands/SchedulesDraftCommand';
import { SetOfDayTypesCommand } from '../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { ScheduleActiveForm } from './ScheduleActiveForm';
import { ScheduleDraftForm } from './ScheduleDraftForm';
import { SchedulesActive } from './SchedulesActive';
import { SchedulesDraft } from './SchedulesDraft';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';

export class Schedules extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    schedules: [],
                },
                draft: {
                    schedules: [],
                }
            },
            dependencies: {
                setOfDayTypes: []
            },
            form: {
                active: {
                    schedule: undefined
                },
                draft: {
                    schedule: undefined
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 50
                },
                draft: {
                    page: 1,
                    elementsPerPage: 50
                }
            },
            actions: {
                active: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                isLoadingSetOfDayTypes: true,
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    schedules: new SchedulesCommand(),
                },
                draft: {
                    schedules: new SchedulesDraftCommand(),
                },
                setOfDayTypes: new SetOfDayTypesCommand()
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        // Not associated with any type of Edition
        this.getSetOfDayTypes();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updatePlanning() {
        const { actions } = this.state;

        actions.active.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getSchedules(edition, "active");
        });
    }

    updateDraftPlanning() {
        const { actions } = this.state;

        actions.draft.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getSchedules(edition, "draft");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    listDependenciesSuccessCallback(result, updateData, updateAction, callback) {
        const { dependencies, actions } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listDependenciesErrorCallback(messageReceived, updateData, updateAction) {
        const { dependencies, actions, message } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    getSchedules(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoading = true;
        commands[dataType].schedules.get(
            edition,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "schedules", "isLoading"),
            (a) => this.listErrorCallback(a, dataType, "schedules", "isLoading")
        );

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypes() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingSetOfDayTypes = true;
        commands.setOfDayTypes.getAll(
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes"),
            (a) => this.listDependenciesErrorCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes")
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].schedule.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].schedule.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        form[dataType].schedule = {
            title: "Criar",
            type: "create",
            original: undefined,
            obj: {
                id: 0,
                planningEdition: 0,
                name: "",
                setOfDayTypes: undefined,
                setOfDayTypesId: 0
            },
            nameInputError: null
        };

        this.setState({
            form: form
        });
    }

    onEditClick(schedule, dataType) {
        const { form, render } = this.state;

        if (render.compare) {
            const { data } = this.state;

            schedule = data[dataType].schedules.find(unmuted => unmuted.id === schedule.id);
        }

        form[dataType].schedule = {
            title: "Editar",
            type: "edit",
            original: schedule,
            obj: Object.assign({
                id: 0,
                planningEdition: 0,
                name: "",
                setOfDayTypes: undefined,
                setOfDayTypesId: 0
            }, schedule),
            nameInputError: null
        };

        this.setState({
            form: form
        });
    }

    onScheduleFormExit(dataType) {
        const { form } = this.state;

        form[dataType].schedule = undefined;

        this.setState({
            form: form
        });
    }

    onDeleteClick(schedule, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o horário "${schedule.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    id: schedule.id,
                    planningEdition: schedule.planningEdition,
                    dataType: dataType
                }
            }
        });
    }

    onSave(dataType) {
        if (this.isValidInput(dataType)) {
            const { edition } = this.context;
            const { form, commands, actions } = this.state;

            actions[dataType].isUpdating = true;

            const callback = () => this.getSchedules(edition, dataType);
            commands[dataType].schedules.save(
                edition,
                form[dataType].schedule.obj,
                (a) => this.operationSuccessCallback(a, "isUpdating", dataType, callback),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType)
            );

            this.setState({
                actions: actions
            });

            this.onScheduleFormExit(dataType);
        }
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { edition } = this.context;
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete":
                    actions[argument.dataType].isDeleting = true;
                    commands[argument.dataType].schedules.delete(
                        argument.planningEdition,
                        argument.id,
                        (a) => this.operationSuccessCallback(a, "isDeleting", argument.dataType, () => this.getSchedules(edition, argument.dataType)),
                        (a) => this.operationErrorCallback(a, "isDeleting", argument.dataType)
                    );
                    break;

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        form[dataType].schedule.nameInputError = null;

        if (undefined === form[dataType].schedule.obj.name || null === form[dataType].schedule.obj.name || "" === form[dataType].schedule.obj.name) {
            form[dataType].schedule.nameInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    // ----------------------

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.schedule) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <ScheduleActiveForm show={true}
                form={form.active.schedule}
                setOfDayTypes={dependencies.setOfDayTypes}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onSave={() => this.onSave("active")}
                onHide={() => this.onScheduleFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.schedule) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <ScheduleDraftForm show={true}
                form={form.draft.schedule}
                setOfDayTypes={dependencies.setOfDayTypes}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onSave={() => this.onSave("draft")}
                onHide={() => this.onScheduleFormExit("draft")} />
        );
    }

    renderSchedulesActive() {
        const { data, actions, render, pagination } = this.state;

        return (
            <SchedulesActive schedules={data.active.schedules}
                draftSchedules={data.draft.schedules}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                isLoading={actions.active.isLoading || (render.isComparing && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onEditClick={(a) => this.onEditClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderSchedulesDraft() {
        const { data, actions, pagination, render } = this.state;

        if (actions.draft.isLoading) {
            return (<LoadingSpinner />)
        }

        return (
            <SchedulesDraft schedules={data.draft.schedules}
                currentPage={pagination.draft.page}
                elementsPerPage={pagination.draft.elementsPerPage}
                isLoading={actions.draft.isLoading}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onEditClick={(a) => this.onEditClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { render } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.isComparing}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanger_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderSchedulesActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderSchedulesDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render.tab)}
            </div>
        );
    }

    renderButtons(selectedTab) {
        if ("active" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("active")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("draft")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, render, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Horários" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        {this.renderButtons(render.tab)}
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdating || actions.active.isDeleting || actions.draft.isUpdating || actions.draft.isDeleting
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
